module.exports = __webpack_public_path__ + "img/img2.93065359.png";